'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bomb';
var width = 576;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = ['M80 304c0 88.4 71.6 160 160 160s160-71.6 160-160c0-18.8-3.2-36.8-9.1-53.5l-5.1-14.3c6-6 15.4-15.4 28.3-28.3L336 129.9c-12.8 12.8-22.3 22.3-28.3 28.3l-14.3-5.1c-16.7-5.9-34.7-9.1-53.5-9.1-88.4 0-160 71.6-160 160zm48 0c0-61.9 50.1-112 112-112l24 0 0 48-24 0c-35.3 0-64 28.7-64 64l0 24-48 0 0-24z', 'M456 88l-64-24 64-24 24-64 24 64 64 24-64 24-24 64-24-64zM336 62.1l17 17 112 112 17 17c-10.1 10.1-23.8 23.8-41.2 41.2 4.8 17.5 7.3 35.8 7.3 54.8 0 114.9-93.1 208-208 208S32 418.9 32 304 125.1 96 240 96c18.9 0 37.3 2.5 54.8 7.3 17.4-17.4 31.1-31.1 41.2-41.2zm0 67.9c-12.8 12.8-22.3 22.3-28.3 28.3l-14.3-5.1c-16.7-5.9-34.7-9.1-53.5-9.1-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-18.8-3.2-36.8-9.1-53.5l-5.1-14.3c6-6 15.4-15.4 28.3-28.3L336 129.9zM176 304l0 24-48 0 0-24c0-61.9 50.1-112 112-112l24 0 0 48-24 0c-35.3 0-64 28.7-64 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;